import React from 'react';
import Typography from '@mui/material/Typography';
import styles from './styles';
import ImageHoverZoom from './ImageHoverZoom';

function PackageOptions(props) {
  return (
    <div style={styles.optionBox}>
        <ImageHoverZoom src={props.image} alt={props.alt}/>
        <Typography variant='subtitle1' style={styles.optionCaption}>
          {props.packageType}
        </Typography>
        {props.subText && (
          <Typography 
            variant='caption' 
            style={{
              ...styles.optionCaption,
              color: '#666',
              fontSize: '0.75rem',
              marginTop: '4px'
            }}
          >
            {props.subText}
          </Typography>
        )}
    </div>
  );
}

export default PackageOptions;